import { Box } from "@mui/material";
import styles from "./styles";

const BlocBackground = () => (
  <Box className={"container"} sx={styles}>
    <div className={"texte"}>
      <h2>Administrateurs de biens :</h2>
      <h1>
        <strong>sécurisez & développez votre activité</strong>
        <br />
        de gestion locative
      </h1>
      <h1>
        avec <span className="vertuloo-font-lg">vertuloo</span>
        <br />
        votre plateforme digitale
      </h1>
    </div>
    <div className={"imageBg"} />
  </Box>
);

export default BlocBackground;
